import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const ViewFiltersContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewFiltersContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrganizationView"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrganizationView"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idBoards"}},{"kind":"Field","name":{"kind":"Name","value":"idLists"}},{"kind":"Field","name":{"kind":"Name","value":"idMembers"}},{"kind":"Field","name":{"kind":"Name","value":"due"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"end"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"special"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueComplete"}},{"kind":"Field","name":{"kind":"Name","value":"dateLastActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"end"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultViewType"}},{"kind":"Field","name":{"kind":"Name","value":"viewOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Calendar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeHorizon"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ViewFiltersContext","document":ViewFiltersContextDocument}} as const;
export type ViewFiltersContextQueryVariables = Types.Exact<{
  idOrganizationView: Types.Scalars['ID']['input'];
}>;


export type ViewFiltersContextQuery = (
  { __typename: 'Query' }
  & { organizationView?: Types.Maybe<(
    { __typename: 'OrganizationView' }
    & Pick<Types.OrganizationView, 'id' | 'name' | 'idOrganization'>
    & { prefs: (
      { __typename: 'OrganizationView_Prefs' }
      & Pick<Types.OrganizationView_Prefs, 'permissionLevel'>
    ), views: Array<(
      { __typename: 'OrganizationView_View' }
      & Pick<Types.OrganizationView_View, 'id' | 'defaultViewType'>
      & { cardFilter: (
        { __typename: 'OrganizationView_View_CardFilter' }
        & { criteria: Array<(
          { __typename: 'OrganizationView_View_CardFilter_Criteria' }
          & Pick<Types.OrganizationView_View_CardFilter_Criteria, 'idBoards' | 'idLists' | 'idMembers' | 'dueComplete' | 'labels' | 'sort'>
          & { due?: Types.Maybe<(
            { __typename: 'CardFilter_Criteria_DateRange' }
            & Pick<Types.CardFilter_Criteria_DateRange, 'special'>
            & { start?: Types.Maybe<(
              { __typename: 'CardFilter_AdvancedDate' }
              & Pick<Types.CardFilter_AdvancedDate, 'dateType' | 'value'>
            )>, end?: Types.Maybe<(
              { __typename: 'CardFilter_AdvancedDate' }
              & Pick<Types.CardFilter_AdvancedDate, 'dateType' | 'value'>
            )> }
          )>, dateLastActivity?: Types.Maybe<(
            { __typename: 'CardFilter_Criteria_DateRange' }
            & { start?: Types.Maybe<(
              { __typename: 'CardFilter_AdvancedDate' }
              & Pick<Types.CardFilter_AdvancedDate, 'dateType' | 'value'>
            )>, end?: Types.Maybe<(
              { __typename: 'CardFilter_AdvancedDate' }
              & Pick<Types.CardFilter_AdvancedDate, 'dateType' | 'value'>
            )> }
          )> }
        )> }
      ), viewOptions?: Types.Maybe<(
        { __typename: 'OrganizationView_View_ViewOptions' }
        & { Calendar?: Types.Maybe<(
          { __typename: 'OrganizationView_View_ViewOptions_Calendar' }
          & Pick<Types.OrganizationView_View_ViewOptions_Calendar, 'timeHorizon'>
        )> }
      )> }
    )> }
  )> }
);

/**
 * __useViewFiltersContextQuery__
 *
 * To run a query within a React component, call `useViewFiltersContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewFiltersContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewFiltersContextQuery({
 *   variables: {
 *      idOrganizationView: // value for 'idOrganizationView'
 *   },
 * });
 */
export function useViewFiltersContextQuery(
  baseOptions: TrelloQueryHookOptions<
    ViewFiltersContextQuery,
    ViewFiltersContextQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: ViewFiltersContextDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    ViewFiltersContextQuery,
    ViewFiltersContextQueryVariables
  >(ViewFiltersContextDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useViewFiltersContextLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    ViewFiltersContextQuery,
    ViewFiltersContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ViewFiltersContextQuery,
    ViewFiltersContextQueryVariables
  >(ViewFiltersContextDocument, options);
}
export type ViewFiltersContextQueryHookResult = ReturnType<
  typeof useViewFiltersContextQuery
>;
export type ViewFiltersContextLazyQueryHookResult = ReturnType<
  typeof useViewFiltersContextLazyQuery
>;
export type ViewFiltersContextQueryResult = Apollo.QueryResult<
  ViewFiltersContextQuery,
  ViewFiltersContextQueryVariables
>;
